import { FC } from "react";
import { TagProps } from "../../../typings/tag";

export type AgeFilteredSelectedProps = {
   ages: TagProps[];
   minAge: number;
   maxAge: number;
   setMinAge: (value: number) => void;
   setMaxAge: (value: number) => void;

}

const AgeFilterSelected: FC<AgeFilteredSelectedProps> = ({ setMinAge, setMaxAge, ages, minAge, maxAge }) => {
   return (
      <>
         <div className="field_block duo">
            <label htmlFor="name">מגיל</label>
            <select className="txt_field age w-select" value={minAge} onChange={(e: any) => setMinAge(e.target.value)}>
               {ages.map((option) => (
                  <option key={option.value} value={option.value}>{option.text}</option>
               ))}
            </select>
            <div className="form_allert">----------------------------</div>
         </div>
         <div className="field_block duo">
            <label htmlFor="name">עד גיל</label>
            <select className="txt_field age w-select" value={maxAge} onChange={(e: any) => setMaxAge(e.target.value)}>
               {ages.filter(age => age.value > minAge).map((option) => (
                  <option key={option.value} value={option.value}>{option.text}</option>
               ))}
            </select>
            <div className="form_allert">----------------------------</div>
         </div>
      </>
   )

}

export default AgeFilterSelected;
